<template>
  <div id="recording-tab-info">
    <vx-card
      class="mb-base"
      id="info-account-area"
      style="background: #f7f7f7; border-top: 1px solid #eee; padding-top: 16px"
    >
      <div class="vs-row">
        <div class="background-container">
          <img
            :src="
              content && content?.recording
                ? content?.recording?.program?.photo
                : ''
            "
          />
        </div>
      </div>
      <vs-row style="margin-top: 16px">
        <table class="recording-info">
          <tr>
            <td class="recording-label"><span>Programa</span></td>
            <td class="content-text font-semibold program-name-detail">
              {{
                content?.recording &&
                content?.recording?.program &&
                content?.recording?.program.name
              }}{{
                content.recording && content?.recording?.frame
                  ? ` (${content?.recording?.frame?.name})`
                  : ""
              }}
            </td>
          </tr>
          <tr>
            <td class="recording-label"><span>Data</span></td>
            <td class="content-text font-semibold">
              {{ content.recording && content.recording.date | formatDate }}
            </td>
          </tr>
          <tr>
            <td class="recording-label">Hora no SBT</td>
            <td class="content-text font-semibold">
              {{ content.recording && content.recording.time | formatTime }}
            </td>
          </tr>

          <tr>
            <td class="recording-label">Idade Mínima</td>
            <td class="content-text font-semibold">
              {{ content.recording && content.recording.ageMin }} anos
            </td>
          </tr>
          <tr>
            <td class="recording-label">Status</td>
            <td
              v-if="content.recording"
              :class="getStatusColor(content.recording.status)"
            >
              {{ content.recording.status ? "Ativo" : "Desativado" }}
            </td>
          </tr>
          <tr>
            <td class="recording-label">Vagas (total)</td>
            <td class="content-text vacancy">
              <div class="chip-gender">
                <div class="quantity-gender">
                  {{ content.recording?.caravanist?.vacancies }}
                </div>
                <span class="span-gender">Homem</span>
              </div>
              <div class="chip-gender">
                <div class="quantity-gender">
                  {{ content.recording?.caravanist?.numberMen }}
                </div>
                <span class="span-gender">Mulher</span>
              </div>
            </td>
          </tr>
          <tr>
            <td class="recording-label">Solicitados</td>
            <td class="content-text font-semibold">
              {{
                content.recording &&
                content.recording?.caravanist?.numberParticipants
              }}
            </td>
          </tr>
          <tr>
            <td class="recording-label">Confirmado</td>
            <td class="content-text font-semibold">
              {{ content.recording && content.recording.confirmed }}
            </td>
          </tr>
        </table>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
    };
  },
  computed: {
    content() {
      return JSON.parse(JSON.stringify(this.data));
    },
  },
  methods: {
    getStatusColor(status) {
      return !status ? "text-danger" : "text-success";
    },
    toggleDataSidebar(active = false) {
      this.addNewDataSidebar = active;
    },
  },
  filters: {
    formatDate: (value) => {
      if (!value) return "";
      return value.replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1");
    },
    firstLetter: (value) => {
      if (!value) return "";
      return String(value[0] || " ").toUpperCase();
    },
    formatTime: (value) => {
      return (value || "").replace(":00", "");
    },
  },
  mounted() {
    this.addNewDataSidebar = false;
  },
};
</script>

<style lang="scss">
.program-name-detail {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
.chip-gender {
  margin-right: 2px;
  background: #eee;
  padding: 2px 8px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 75px;
  justify-content: space-between;
}
.quantity-gender {
  color: #000;
  font-weight: bold;
}
.span-gender {
  font-size: 11px;
}
.recording-title {
  font-size: 17px;
  font-weight: bolder;
  text-align: center;
  margin: 16px 10px;
}
.background-container {
  width: 100%;
  border-radius: 6px;
  background: #eee;
  height: 150px;
}
.background-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.recording-title-banner {
  position: absolute;
  bottom: 10px;
  background: #fff;
}

.recording-info {
  font-size: 13px;
}
.mb-base table {
  table-layout: fixed;
}
.font-semibold {
  font-size: 15px !important;
}
.recording-label {
  font-size: 15px;
  width: 125px !important;
}

#recording-tab-info {
  .divisor {
    padding: 0 7px;
  }
  #account-manage-buttons {
    margin: 1em 0 0 0;
  }
  .rounded-letter,
  img.rounded {
    width: 77px;
    height: 77px;
  }
  img.rounded {
    height: auto;
    margin: 0 1em 0 0;
  }
  .rounded-letter {
    padding: 21px 0;
    margin: 0 21px 0 0;
    display: block;
    text-align: center;
    font-size: 2.5em;
    border-radius: 100%;
    line-height: 100%;
    background-color: #ccc;
  }
  .recording-name {
    max-width: 15rem;
  }
  .content-text p {
    word-break: break-all;
    line-height: 1.3em;
  }
}
@media screen and (max-width: 420px) {
  #recording-tab-info {
    .divisor {
      display: none;
    }
    .vacancy {
      display: flex;
      flex-direction: row;
    }
    .label-women,
    .label-men {
      word-break: keep-all;
      white-space: nowrap;
    }
    .vx-row {
      display: block;
    }
    .vx-card__body {
      padding-top: 0 !important;
    }
    #logo-col {
      display: none;
    }
    .recording-info {
      tr + tr td {
        padding-top: 5px;
      }
    }
  }
}
</style>
